import script from "./MindMap.vue?vue&type=script&setup=true&lang=js"
export * from "./MindMap.vue?vue&type=script&setup=true&lang=js"

import "./MindMap.vue?vue&type=style&index=0&id=ed079c56&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kevin\\Desktop\\ArbeitFinderundBeraterVersionen\\MonitorBerater\\MonitorweltBerater\\FindingoBerater\\BeforeWordpressBerater_new_WordpressProduction\\newDataForm\\newDataForm\\form_try0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed079c56"]])

export default __exports__